import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CustomizerSummaryModel } from '@models/customizer-summary-model';
import { TempleInclinationEnum } from '@models/variant-temple-inclination';
import { TranslatePipe } from '@ngx-translate/core';
import { DataTranslatePipe } from '@pipes/data-translate.pipe';
import { ReplaceHashPipe } from '@pipes/replace-hash.pipe';
import { EngravingService } from '@services/engraving.service';
import { SubMenuStateEnum, SubMenuStateTogglerService } from '@services/sub-menu-state-toggler.service';
import { CombinedColorNameComponent } from '../combined-color-name/combined-color-name.component';

@Component({
	selector: 'cstmsr-summary-sidebar',
	templateUrl: './summary-sidebar.component.html',
	styleUrls: ['./summary-sidebar.component.scss'],
	animations: [],
	imports: [ReplaceHashPipe, CommonModule, TranslatePipe, DataTranslatePipe, CombinedColorNameComponent],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummarySidebarComponent implements OnInit, OnChanges {

	@Input() variants: Array<CustomizerSummaryModel>;
	@Input() modelCode?: string;
	@Input() modelSize?: string | undefined;
	@Input() templeInclination?: TempleInclinationEnum | null;

	variantsToShow: Array<CustomizerSummaryModel> = [];
	engraving?: string;

	icons: Map<string, string> = new Map<string, string>();

	get templeInclinationTranslationKey(): string {
		return this.templeInclination === TempleInclinationEnum.low ? 'BAG.TEMPLE.LOW' : 'BAG.TEMPLE.STANDARD';
	}

	constructor(
		private subMenuStateTogglerService: SubMenuStateTogglerService,
		private engravingService: EngravingService
	) { }

	async ngOnInit() {
		this.initIcons(this.variantsToShow.map(v => v.ComponentCode));
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['variants'] && changes['variants'].currentValue) {
			this.variantsToShow = (changes['variants'].currentValue as Array<CustomizerSummaryModel>).sortBy(v => v.ComponentCode);
		}

		this.engraving = this.engravingService.engraving;
	}

	getState() {
		this.subMenuStateTogglerService.toggle.subscribe(s => {
			switch (s) {
				case SubMenuStateEnum.configOpen:
					return 'expand';

				case SubMenuStateEnum.configClose:
					return 'collapse';

				default:
					return 'collapse'
			}
		});
	}

	private initIcons(variantCodes: Array<string | undefined>) {
		variantCodes?.forEach(code => {
			if (code)
				this.icons.set(code, this.getIconForVariantCode(code))
		});
	}

	private getIconForVariantCode(variantCode: string): string {
		switch (variantCode) {
			case "BRIDGE":
			case "BRIDGE_CLIP": //there is no 'bridge clip' icon, should we get one or combine the two variants?
				return "bridge";
			case "CLIP-ON":
				return "clip-on";
			case "COVER":
				return "temple-cover-color";
			case "CROSSBAR":
				return "crossbar";
			case "FRONT":
				return "front";
			case "GEMSTONE":
				return "gemstone";
			case "GROOVE":
				return "groove-color";
			case "INNERRIM":
				return "inner-rim-color";
			case "LENSES":
				return "lens-color";
			case "LOWERRIM":
				return "lower-rim-color";
			case "NOSEPAD":
				return "nosepads";
			case "TEMPLE":
				return "temple";
			case "TEMPLE_CLIP":
				return "clip-color";
			case "UPPERRIM":
				return "upper-rim-color";
			default:
				return "not-found";
		}
	}

}
